import { /*getValidDate,*/ getFormatNumPlus } from '@gp/utils/common';
import { ECHART_COLOR } from '@gp/constants/const';
import { BASE_ECHART_OPTION, BASE_BAR_SERIES_OPTION, Y_AXIS_NAME_CURRENCY_OPTION, Y_AXIS_NAME_CURRENCY_GRID_OPTION } from '@gp/constants/echarts';

const getEChartOpt = (data: orgHeadcountsDataTypes) => {
  const xAxisLabelList: string[] = []; // x轴刻度名列表
  const targetMetrics = data?.metrics || [],
    targetData = data?.dataList || [];
  const _series = [];
  if (Array.isArray(targetMetrics) && targetMetrics?.length) {
    for (let i = 0; i < targetMetrics?.length; i++) {
      const t: string = targetMetrics?.[i];
      const dataList: {
        value: string | null;
        data: { [key: string]: string } | null;
      }[] = []; // 每个指标每个刻度的数据
      for (let j = 0; j < targetData?.length; j++) {
        const k: { [key: string]: string } = targetData?.[j];
        i === 0 && xAxisLabelList?.push(k?.['date']);
        // i === 0 && xAxisLabelList?.push(getValidDate(k?.['date'], 'MMM,YYYY'));
        dataList.push({
          value: k?.[t] || null,
          data: k || null,
        });
      }
      _series.push({
        ...BASE_BAR_SERIES_OPTION,
        name: t,
        type: 'bar',
        // stack: 'metric',
        barMaxWidth: 64,
        barGap: '4%',
        data: dataList,
        /* emphasis: {
          focus: 'series',
        }, */
        label: {
          distance: 100,
        },
      });
    }
  }

  return {
    ...BASE_ECHART_OPTION,
    grid: {
      ...BASE_ECHART_OPTION.grid,
      ...Y_AXIS_NAME_CURRENCY_GRID_OPTION,
    },
    color: ECHART_COLOR,
    title: {
      show: false,
    },
    xAxis: {
      ...BASE_ECHART_OPTION.xAxis,
      data: xAxisLabelList,
      axisLabel: {
        ...BASE_ECHART_OPTION.xAxis?.axisLabel,
        margin: 16,
      },
    },
    yAxis: [
      {
        ...BASE_ECHART_OPTION.yAxis?.[0],
        ...Y_AXIS_NAME_CURRENCY_OPTION,
        type: 'value',
        axisLabel: {
          // 刻度文案设置
          ...BASE_ECHART_OPTION.yAxis?.[0]?.axisLabel,
          formatter: (value: any) => getFormatNumPlus(value, 2, false),
        },
        // minInterval: 5,
        // maxInterval: 5,
        // interval: 5,
      },
    ],
    series: _series,
  };
};

// tooltip浮窗内容
const tootipFormatter = (params: any) => {
  let name = '',
    firItemListStr = '', // 第一列名称
    secItemListStr = ''; // 第二列数据

  const paramsLen: number = params?.length || 0;
  if (Array.isArray(params) && paramsLen) {
    for (let i = 0; i < paramsLen; i++) {
      const t = params?.[i];
      if (!name) name = t?.data?.data?.date;
      // if (!name) name = getValidDate(t?.data?.data?.date, 'YYYY-MM');
      firItemListStr += `
      <div class="dbg-flex  margin-10">
        <span class='general-circular-dot' style="background-color: ${t?.color};"></span>
        <div>${t?.seriesName}</div>
      </div>
      `;
      secItemListStr += `<div class='body-num  margin-10' style="text-align: right;">${getFormatNumPlus(
        t?.value,
      )}</div>`;
    }
  }

  const htmlStr = `
  <section class='echart-tooltip-style-content'>
  <div class="header-flex">
    <div style="margin-right: 20px">
      <div class="margin-10">${name || '-'}</div>
      <div class="header-title">
        ${firItemListStr || '-'}
      </div>
    </div>
    <div style="">
      <div class="margin-10">&nbsp;</div>
      <div>
        ${secItemListStr || '-'}
      </div>
    </div>
  </div>
  <section>
  `;
  return htmlStr;
};

export { getEChartOpt, tootipFormatter };
